// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCtKTRnwHeR9XhNllMal6p47OW0HfILV5Q',
    authDomain: 'centric-cms.firebaseapp.com',
    databaseURL: 'https://centric-cms.firebaseio.com',
    projectId: 'centric-cms',
    storageBucket: 'centric-cms.appspot.com',
    messagingSenderId: '908429946774',
    appId: '1:908429946774:web:8cf2145c559843db'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
